module.exports = __webpack_public_path__ + "img/2025-05-09a_3.6ebd9701.jpg";